import { createApp } from 'vue';
import PptxToPdfAConverter from '@/Components/PptxToPdfAConverter.vue';
import '@styles/app.css';

createApp(PptxToPdfAConverter).mount('#pptx-to-pdfa-converter');
